import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '../hooks';

type Props = {
  children: React.ReactNode;
  redirectTo?: string;
  requireSub?: boolean;
  requireOrg?: boolean;
  requireOrgAdmin?: boolean;
};

// Use the Auth State from React Query here to check if the user is logged in
// Redirect to login page if the user is not logged in
export const RequireAuth = ({
  children,
  redirectTo,
  requireSub,
  requireOrg,
  requireOrgAdmin,
}: Props) => {
  const { user } = useCurrentUser();

  if (!user) {
    return <Navigate to={redirectTo || '/login'} replace />;
  }

  if (requireSub && !user.subscription) {
    return <Navigate to={redirectTo || '/plus/cart-history'} replace />;
  }

  if (requireOrg && user.subscription.tier !== 'organization') {
    return <Navigate to={redirectTo || '/plus/cart-history'} replace />;
  }

  if (
    requireOrgAdmin &&
    !(
      user.subscription.tier === 'organization' &&
      user.subscription.role === 'admin'
    )
  ) {
    return <Navigate to={redirectTo || '/login'} replace />;
  }

  return <>{children}</>;
};
